import config from "../../config";

const getAccountId = () => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    return user.accountId;
};

const buildUrl = (path, params = {}) => {
    const filtered = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
    );
    const qs = new URLSearchParams({ account_id: getAccountId(), ...filtered });
    return `${config.apiUrl}/${path}?${qs}`;
};

const parseErrorMessage = async (res, fallback) => {
    let msg = fallback;
    try {
        const j = await res.json();
        msg = j?.error || j?.message || msg;
    } catch { }
    return msg;
};

const postJson = async (path, body) => {
    const res = await fetch(`${config.apiUrl}/${path}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ account_id: getAccountId(), ...body }),
    });
    if (!res.ok) {
        const msg = await parseErrorMessage(res, `HTTP ${res.status}`);
        throw new Error(msg);
    }
    return res.json();
};

const putJson = async (path, body) => {
    const res = await fetch(`${config.apiUrl}/${path}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ account_id: getAccountId(), ...body }),
    });
    if (!res.ok) {
        const msg = await parseErrorMessage(res, `HTTP ${res.status}`);
        throw new Error(msg);
    }
    return res.json();
};

const del = async (path, params) => {
    const res = await fetch(buildUrl(path, params), { method: "DELETE" });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
};

const get = async (path, params = {}) => {
    const res = await fetch(buildUrl(path, params));
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
};

/* ════════════════════════════════════════════════════════════════
   QUOTATION
   ════════════════════════════════════════════════════════════════ */
export const getQuotations = (p = {}) => get("getQuotations", p);
export const getQuotationKpis = () => get("getQuotationKpis");
export const getQuotationById = (id) => get("getQuotationById", { id });
export const createQuotation = (data) => postJson("createQuotation", data);
export const updateQuotation = (id, data) => putJson("updateQuotation", { id, ...data });
export const deleteQuotation = (id) => del("deleteQuotation", { id });

/* ════════════════════════════════════════════════════════════════
   SALES ORDER
   ════════════════════════════════════════════════════════════════ */
export const getSalesOrders = (p = {}) => get("getSalesOrders", p);
export const getSalesOrderKpis = () => get("getSalesOrderKpis");
export const getSalesOrderById = (id) => get("getSalesOrderById", { id });
export const createSalesOrder = (data) => postJson("createSalesOrder", data);
export const updateSalesOrder = (id, data) => putJson("updateSalesOrder", { id, ...data });
export const deleteSalesOrder = (id) => del("deleteSalesOrder", { id });

/* ════════════════════════════════════════════════════════════════
   DELIVERY ORDER
   ════════════════════════════════════════════════════════════════ */
export const getDeliveryOrders = (p = {}) => get("getDeliveryOrders", p);
export const getDOKpis = () => get("getDOKpis");
export const getDOById = (id) => get("getDOById", { id });
export const createDeliveryOrder = (data) => postJson("createDeliveryOrder", data);
export const updateDeliveryOrder = (id, data) => putJson("updateDeliveryOrder", { id, ...data });
export const deleteDeliveryOrder = (id) => del("deleteDeliveryOrder", { id });

/* ════════════════════════════════════════════════════════════════
   INVOICE
   ════════════════════════════════════════════════════════════════ */
export const getInvoices = (p = {}) => get("getInvoices", p);
export const getInvoiceKpis = () => get("getInvoiceKpis");
export const getInvoiceById = (id) => get("getInvoiceById", { id });
export const createInvoice = (data) => postJson("createInvoice", data);
export const updateInvoice = (id, data) => putJson("updateInvoice", { id, ...data });
export const deleteInvoice = (id) => del("deleteInvoice", { id });